import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import { defineMessages, injectIntl } from "react-intl";
import styles from "./CCForm.scss";
import classnames from "classnames";
import { GuaranteeMessage } from "~/components";
const msgs = defineMessages({
  ccType: {
    id: "checkout.payment_form.ccType",
    description: "ccType",
    defaultMessage: "Credit Card Type",
  },
  ccHolderName: {
    id: "checkout.payment_form.ccHolderName",
    description: "ccHolderName",
    defaultMessage: "Credit Card Holder Name",
  },
  ccNumber: {
    id: "checkout.payment_form.ccNumber",
    description: "ccNumber",
    defaultMessage: "Credit Card Number",
  },
  ccSecurityCode: {
    id: "checkout.payment_form.ccSecurityCode",
    description: "ccSecurityCode",
    defaultMessage: "CVC",
  },
  ccExpirationMonth: {
    id: "checkout.payment_form.ccExpirationMonth",
    description: "CC expiration month",
    defaultMessage: "Month.",
  },
  ccExpirationYear: {
    id: "checkout.payment_form.ccExpirationYear",
    description: "CC expiration year",
    defaultMessage: "Year.",
  },
});

function isFieldInvalid(fieldName, fields) {
  return fields[fieldName] && fields[fieldName].touched && fields[fieldName].error;
}

class CCForm extends React.Component {
  constructor() {
    super();
    this.handleMonthChange = this.handleMonthChange.bind(this);
  }

  handleMonthChange(event) {
    if (event.target.value.length === 2) {
      this.yearInput.focus();
    }
    return null;
  }
  render() {
    const {
      intl: { formatMessage } = {},
      fields: { ccType, ccHolderName, ccNumber, expirationMonth, expirationYear, securityCode },
      description,
      fields,
      handleSubmit,
      creditCardTypes,
      depositTotal,
      creditCardsList,
      paymentType,
    } = this.props;

    //Removes invalid so it doesn't get passed down as a prop
    const { invalid: _a, ...ccTypeProps } = ccType || {};
    const { invalid: _b, ...ccHolderNameProps } = ccHolderName || {};
    const { invalid: _c, ...ccNumberProps } = ccNumber || {};
    const { invalid: _d, ...expirationMonthProps } = expirationMonth || {};
    const { invalid: _e, ...expirationYearProps } = expirationYear || {};
    const { invalid: _f, ...securityCodeProps } = securityCode || {};

    return (
      <div className={classnames("wbkv9-CCForm", styles.ccFormmContainer)}>
        <div
          className={classnames(
            "wbkv9-CCForm-guaranteeMessageContainer",
            styles.guaranteeMessageContainer
          )}>
          <GuaranteeMessage
            depositTotal={depositTotal}
            creditCardsList={creditCardsList}
            description={description}
          />
        </div>
        {/* if there's no ccNumber (which means there are no other cc fields , we disable the form */}
        {ccNumber && (
          <div
            className={classnames(
              "wbkv9-CCForm-formContainer",
              styles.formContainer,
              styles.fieldGroup
            )}>
            <div
              className={classnames(
                "wbkv9-CCForm-field",
                styles.field,
                isFieldInvalid("ccType", fields) && styles.invalid
              )}>
              <select
                type="text"
                {...ccTypeProps}
                className={classnames({
                  "wbkv9-CCForm-field-ccType--selected": !!fields.ccType.value,
                  [styles.selected]: !!fields.ccType.value,
                  "wbkv9-CCForm-field-ccType--unselected": !fields.ccType.value,
                  [styles.unselected]: !fields.ccType.value,
                })}>
                <option value="" disabled hidden>
                  {formatMessage(msgs.ccType)}
                </option>
                {creditCardTypes &&
                  creditCardTypes.map(type => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
              </select>
            </div>

            <div className={classnames("wbkv9-CCForm-number-expDate", styles.numberExpDate)}>
              <div
                id={`${paymentType ? paymentType + "-" : ""}wbkv9-cc-number`}
                className={classnames(
                  "wbkv9-CCForm-field",
                  styles.field,
                  styles.ccNumber,
                  isFieldInvalid("ccNumber", fields) && styles.invalid
                )}>
                <input type="text" placeholder={formatMessage(msgs.ccNumber)} {...ccNumberProps} />
              </div>

              <div
                className={classnames(
                  "wbkv9-CCForm-expirationDate",
                  styles.expirationDate,
                  (isFieldInvalid("expirationMonth", fields) ||
                    isFieldInvalid("expirationYear", fields)) &&
                    styles.invalid
                )}>
                <div
                  className={classnames(
                    "wbkv9-CCForm-field",
                    styles.field,
                    styles.expirationMonth
                  )}>
                  <input
                    type="text"
                    {...expirationMonthProps}
                    placeholder={formatMessage(msgs.ccExpirationMonth)}
                    maxLength={2}
                    onInput={this.handleMonthChange}
                    className={classnames({
                      "wbkv9-CCForm-field-expirationMonth--selected": !!fields.expirationMonth
                        .value,
                      [styles.selected]: !!fields.expirationMonth.value,
                      "wbkv9-CCForm-field-expirationMonth--unselected": !fields.expirationMonth
                        .value,
                      [styles.unselected]: !fields.expirationMonth.value,
                    })}
                  />
                </div>

                <div
                  className={classnames("wbkv9-CCForm-field", styles.field, styles.expirationYear)}>
                  <input
                    type="text"
                    {...expirationYearProps}
                    placeholder={formatMessage(msgs.ccExpirationYear)}
                    maxLength={4}
                    ref={input => {
                      this.yearInput = input;
                    }}
                    className={classnames({
                      "wbkv9-CCForm-field-expirationYear--selected": !!fields.expirationYear.value,
                      [styles.selected]: !!fields.expirationYear.value,
                      "wbkv9-CCForm-field-expirationYear--unselected": !fields.expirationYear.value,
                      [styles.unselected]: !fields.expirationYear.value,
                    })}
                  />
                </div>
              </div>
            </div>
            <div
              className={classnames(
                "wbkv9-CCForm-holder-ccv-container",
                styles.holderCCVContainer
              )}>
              <div
                className={classnames(
                  "wbkv9-CCForm-field",
                  styles.field,
                  styles.ccHolder,
                  isFieldInvalid("ccHolderName", fields) && styles.invalid
                )}>
                <input
                  type="text"
                  placeholder={formatMessage(msgs.ccHolderName)}
                  {...ccHolderNameProps}
                />
              </div>

              {securityCode && (
                <div
                  id={`${paymentType ? paymentType + "-" : ""}wbkv9-cvc-number`}
                  className={classnames(
                    "wbkv9-CCForm-field",
                    styles.field,
                    styles.cvc,
                    isFieldInvalid("securityCode", fields) && styles.invalid
                  )}>
                  <input
                    type="text"
                    placeholder={formatMessage(msgs.ccSecurityCode)}
                    {...securityCodeProps}
                  />
                </div>
              )}
            </div>
          </div>
          // </form>
        )}
      </div>
    );
  }
}

//TODO: Correct proptypes
// CCForm.propTypes = {
//   fields: PropTypes.array,
//   intl: PropTypes.object,
//   handleSubmit: PropTypes.func,
//   creditCardTypes: PropTypes.object,
//   depositTotal: PropTypes.number,
//   creditCardsList: PropTypes.object,
//   paymentType: PropTypes.any,
//   description: PropTypes.string
// };

export default injectIntl(pure(CCForm));
